import * as React from 'react';
import { SVGProps } from 'react';

const IconItalicSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m6.5 3-3 6H1v2h6V9H5.5l3-6H11V1H5v2h1.5Z" />
  </svg>
);
export default IconItalicSizeXs;
